<template>
    <div class="c2b-breadcrumb">
        <span v-for="(item, index) in items" :key="index"
            class="c2b-breadcrumb-item">

            <span v-show="index !== 0">
                <fa icon="chevron-right" class="c2b-breadcrumb-item-icon"></fa>
            </span>

            <router-link :to="item.path" 
                v-if="!!item.path">{{item.description}}</router-link>

            <span v-if="!item.path">{{item.description}}</span>
        </span>
    </div>
</template>

<script>
export default {
    name: 'BreadcrumbCmp',
    props: {
        items: {
            type: Array,
            default: [],
        },
    },
}
</script>

<style lang="scss" scoped>
.c2b-breadcrumb {
    margin-top: -20px;

    .c2b-breadcrumb-item {
        font-size: .8em;
        letter-spacing: 1px;

        a,span {
            color: #333;
            text-decoration: none;
        }

        a:hover {
            border-bottom: 1px solid #777;
        }

        .c2b-breadcrumb-item-icon {
            margin: 0 10px;
            font-size: .7em;
            color: #777;
        }
    }
}
</style>
